export default __webpack_public_path__ + "static/media/KeenV.799134e8.mp3";